import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteFloorplan } from '../services/deleteFloorplan.service';

export const deleteFloorplanThunk = createAsyncThunk(
  'floorplans/deleteFloorplan',
  async ({ projectId, floorplanId }, { rejectWithValue }) => {
    try {
      await deleteFloorplan(projectId, floorplanId);
      return { id: floorplanId };
    } catch (err) {
      return rejectWithValue({ message: err.message, floorplanId });
    }
  }
);
